'use client' // Error boundaries must be Client Components

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    // global-error must include html and body tags
    <html>
      <body>
        <section className="error__page">
          <div className="container line">
            <span className="line-3" />
            <div className="row">
              <div className="col-xxl-12">
                <div className="error__content">
                  <h2>Something went wrong!</h2>
                  <button
                    className="px-5 py-3 text-lg rounded-md bg-slate-950 text-slate-50 hover:bg-neutral-200 hover:border hover:border-gray-500 hover:text-black"
                    onClick={() => window.location.reload()}>Try again</button>
                  
                  <div className="btn_wrapper pt-4">
                    <a
                      href="/"
                      className="wc-btn-primary btn-hover btn-item"
                    >
                      <span /> Back to <br />
                      Homepage <i className="fa-solid fa-arrow-right" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </body>
    </html >
  )
}